module.exports = __webpack_public_path__ + "media/images/icons/dropdown_arrow_up-ff09fc19d716211df33cc90f57d64fdd.svg";